import React from 'react'

import ProjectEdit from './project-dialog-edit'
import ProjectSaveItem from './project-dialog-save-item'

/*
  Wrap all project related components
*/
const ProjectsRoot = () => {
  return (
    <>
      <ProjectEdit />
      <ProjectSaveItem />
    </>
  )
}

export default ProjectsRoot
